/* eslint-disable */
(function ($) {

    /**
     * initMap
     *
     * Renders a Google Map onto the selected jQuery element
     *
     * @date    22/10/19
     * @since   5.8.6
     *
     * @param   jQuery $el The jQuery element.
     * @return  object The map instance.
     */
    function initMap($el) {

        // Find marker elements within map.
        var $markers = $el.find('.marker');

        // Create gerenic map.
        var mapArgs = {
            zoom: $el.data('zoom') || 16,
            mapTypeId: google.maps.MapTypeId.ROADMAP,

        };
        var map = new google.maps.Map($el[0], mapArgs);

        // Add markers.
        map.markers = [];
        var i = 1;
        $markers.each(function () {
            initMarker($(this), map, i++);
        });

        // Center map based on markers.
        centerMap(map);

        // Return map instance.
        return map;
    }

    /**
     * initMarker
     *
     * Creates a marker for the given jQuery element and map.
     *
     * @date    22/10/19
     * @since   5.8.6
     *
     * @param   jQuery $el The jQuery element.
     * @param   object The map instance.
     * @return  object The marker instance.
     */
    function initMarker($marker, map, i) {

        // Get position from marker.
        var lat = $marker.data('lat');
        var lng = $marker.data('lng');
        var latLng = {
            lat: parseFloat(lat),
            lng: parseFloat(lng)
        };

        var icon = {
            path: "M15,46.2C15,46.3,15,46.3,15,46.2c0,0,15-22.7,15-30.2c0-11-7.6-15.8-15-15.8C7.6,0.3,0,5.1,0,16.1 C0,23.5,15,46.3,15,46.2L15,46.2z M9.8,15.4c0-2.8,2.3-5.1,5.2-5.1s5.2,2.3,5.2,5.1s-2.3,5.1-5.2,5.1C12.1,20.6,9.8,18.3,9.8,15.4z",
            fillColor: '#d02b2e',
            fillOpacity: 1,
            anchor: new google.maps.Point(15, 46),
            strokeWeight: 0,
            scale: 1
        }

        // Create marker instance.
        var marker = new google.maps.Marker({
            position: latLng,
            map: map,
            icon: icon,
            id: i
        });

        const branchDetails = document.querySelector('#branch-details-' + marker.id).innerHTML;

        var infowindow = new google.maps.InfoWindow({
            content: branchDetails
        });

        // Append to reference for later use.
        map.markers.push(marker);

        // google.maps.event.addListener(marker, 'click', (function (marker) {
        //     return function () {
        //         var selected = document.getElementById('detail-' + this.id);
        //         var elements = document.querySelectorAll('.marker-details.active');

        //         if (!selected.classList.contains('thatClass')) {
        //             for (var t = 0; t < elements.length; t++) {
        //                 elements[t].classList.remove("active");
        //             }
        //             selected.classList.add('active');
        //         }
        //     }
        // })(marker));

        google.maps.event.addListener(marker, 'mouseover', e => infowindow.open(map,marker));

        google.maps.event.addListener(marker, 'mouseout', e => infowindow.close(map,marker));

        // If marker contains HTML, add it to an infoWindow.
        if ($marker.html()) {

            // Create info window.
            var infowindow = new google.maps.InfoWindow({
                content: $marker.html()
            });

            // Show info window when marker is clicked.
            google.maps.event.addListener(marker, 'click', function () {
                infowindow.open(map, marker);
            });
        }
    }

    /**
     * centerMap
     *
     * Centers the map showing all markers in view.
     *
     * @date    22/10/19
     * @since   5.8.6
     *
     * @param   object The map instance.
     * @return  void
     */
    function centerMap(map) {

        // Create map boundaries from all map markers.
        var bounds = new google.maps.LatLngBounds();
        map.markers.forEach(function (marker) {
            bounds.extend({
                lat: marker.position.lat(),
                lng: marker.position.lng()
            });
        });

        // Case: Single marker.
        if (map.markers.length == 1) {
            map.setCenter(bounds.getCenter());

            // Case: Multiple markers.
        } else {
            map.fitBounds(bounds);
        }
    }

    // Render maps on page load.
    $(document).ready(function () {
        $('.acf-map').each(function () {
            var map = initMap($(this));
        });

        $('.marker-details .close').click(function () {
            var $parent = $(this).parent();
            $parent.removeClass('active');
        });
    });

})(jQuery);
/* eslint-enable */


// WEBPACK FOOTER //
// ./scripts/partials/google-maps.js